function toMillis() {

  let toMillisDirective = {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attr, ngModel) {

      function fromMillis(minutes) {
        return minutes * 60000;
      }

      function toMinutes(millis) {
        return new Date(millis).getMinutes();
      }

      ngModel.$parsers.push(fromMillis);
      ngModel.$formatters.push(toMinutes);
    }
  };

  return toMillisDirective;

}

export default toMillis;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPick/toMillis.directive.js
 **/